module.exports = __webpack_public_path__ + "static/media/2.342ab4b7.jpg";